import { OrderData } from '../types/cart';
import { logError, logEvent } from '../utils/logger';
import { CartItem, PrintServices } from '../types/cart';

export class EmailService {
  private static readonly EMAIL_ENDPOINT = '/api/notify.php';

  static async sendOrderNotification(data: OrderData): Promise<void> {
    try {
      // Log inicial dos dados recebidos
      console.log('=== Início do processo de email ===');
      console.log('OrderId:', data.orderId);
      console.log('Número de itens:', data.items.length);
      
      // Log detalhado dos itens
      console.log('Detalhes completos dos itens:');
      data.items.forEach((item, index) => {
        console.log(`\nItem ${index + 1}:`, {
          fileName: item.fileName,
          services: item.services,
          quantity: item.quantity,
          price: item.price,
          totalPrice: item.price * item.quantity
        });
      });

      // Validação mais específica dos dados
      if (!data.orderId || !data.customer.email || !data.items.length) {
        throw new Error('Dados incompletos para envio de email');
      }

      // Validação dos serviços de cada item
      for (const item of data.items) {
        if (!item.services || !item.services.technology) {
          console.error('Item com serviços inválidos:', item);
          throw new Error(`Serviços inválidos para o arquivo: ${item.fileName}`);
        }
      }

      const emailPayload = {
        orderId: data.orderId,
        customer: {
          name: data.customer.name,
          email: data.customer.email,
          phone: data.customer.phone
        },
        items: data.items.map(item => ({
          fileName: item.fileName,
          quantity: item.quantity,
          price: item.price,
          services: {
            technology: item.services.technology,
            printer: item.services.printer,
            material: item.services.material,
            color: item.services.color,
            infill: item.services.infill,
            quality: item.services.quality,
            additionalService: item.services.additionalService || ''
          },
          totalPrice: item.price * item.quantity
        })),
        specs: data.specs,
        totalAmount: data.totalAmount
      };

      // Log do payload antes do envio
      console.log('\n=== Payload preparado ===');
      console.log(JSON.stringify(emailPayload, null, 2));

      const response = await fetch(this.EMAIL_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(emailPayload),
        signal: AbortSignal.timeout(30000)
      });

      // Log da resposta do servidor
      console.log('\n=== Resposta do servidor ===');
      console.log('Status:', response.status);
      console.log('Headers:', Object.fromEntries(response.headers.entries()));
      
      const responseText = await response.text();
      console.log('Resposta bruta:', responseText);

      if (!response.ok) {
        throw new Error(`Erro no servidor: ${response.status} - ${responseText}`);
      }

      try {
        const responseData = JSON.parse(responseText);
        console.log('Resposta processada:', responseData);
      } catch (e) {
        console.error('Erro ao parsear resposta JSON:', e);
      }

      console.log('=== Fim do processo de email ===');

    } catch (error) {
      console.error('Erro completo no envio de email:', error);
      throw error;
    }
  }
}